"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestError = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _constants = require("../../../constants");

var _ErrorMessage = require("../../ErrorMessage");

var _useRequestError = require("./useRequestError");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  productType: (0, _propTypes.oneOf)([_constants.ProductTypes.AUTO, _constants.ProductTypes.HOME]),
  onRetry: _propTypes.func.isRequired,
  error: _propTypes.object
} : {};

var RequestError = function RequestError(_ref) {
  var productType = _ref.productType,
      onRetry = _ref.onRetry,
      error = _ref.error;

  var _ref2 = (0, _useRequestError.useRequestError)(productType, onRetry, error),
      handleRetryClick = _ref2.handleRetryClick;

  return (0, _core.jsx)(_ErrorMessage.ErrorMessage, {
    "data-testid": "request-error"
  }, (0, _core.jsx)(_ErrorMessage.ErrorTitle, null, "Ops! Algo deu errado"), (0, _core.jsx)(_ErrorMessage.ErrorDescription, null, "Por algum motivo, n\xE3o conseguimos carregar as informa\xE7\xF5es necess\xE1rias."), (0, _core.jsx)(_ErrorMessage.ErrorAction, {
    onClick: handleRetryClick
  }, "Tentar novamente"));
};

exports.RequestError = RequestError;
process.env.NODE_ENV !== "production" ? RequestError.propTypes = propTypes : void 0;
RequestError.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RequestError",
  "props": {
    "productType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "ProductTypes.AUTO",
          "computed": true
        }, {
          "value": "ProductTypes.HOME",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "onRetry": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "error": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};